import { createContext } from 'react'
import axios from 'axios'

const isClient = typeof window !== 'undefined'

const GEOIP_URL = `/api/geoip`

interface GeolocationResponse {
  status: string
  version: string
  result: {
    country: string
    state: string
    city: string
    ip: string
    state_code: string
  }
}

function setSessionState(state: string) {
  window &&
    window.sessionStorage &&
    window.sessionStorage.setItem('state', state)
}

async function getCustomerState(): Promise<string> {
  if (!isClient || typeof window.URLSearchParams === 'undefined') {
    return ''
  }
  const queryString = new URLSearchParams(window.location.search)
  const queryState = queryString.get('state')
  const ipQueryString = queryString.has('ip')
    ? `?ip=${queryString.get('ip')}`
    : ''
  if (queryState) {
    setSessionState(queryState)
    return queryState
  } else if (window.sessionStorage.state && !ipQueryString) {
    return window.sessionStorage.state
  }
  const response = await axios.get<GeolocationResponse>(
    `${GEOIP_URL}${ipQueryString}`
  )
  const { result } = response.data
  if (result?.country !== 'US') {
    setSessionState('XX')
    return 'XX'
  }
  setSessionState(result.state_code)
  return result.state_code
}

const StateContext = createContext<{
  customerState: string
  setCustomerState: (state: string) => void
}>({ customerState: '', setCustomerState: setSessionState })
StateContext.displayName = 'StateContext'

export { StateContext, getCustomerState, setSessionState }
